import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { LogOut, User, FolderOpen } from 'lucide-react';
import { useGroup, useMember } from '../context/AuthContext';
import { Logo } from './ui';

// Shell for public pages and the member portal
export default function MemberLayout({ children, narrow }) {
  const { group } = useGroup();
  const { member, logout } = useMember();

  return (
    <div className="flex min-h-screen flex-col bg-[#F4F6FA]">
      <header className="bg-navy-900">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-3 px-4 py-3">
          <Link to="/" className="flex min-w-0 items-center gap-3">
            <Logo size={42} />
            <div className="min-w-0">
              <p className="truncate font-display text-lg font-bold leading-tight text-gold-400 sm:text-xl">{group?.name || 'Royal College 2008 Batch'}</p>
              <p className="hidden text-xs text-navy-200 sm:block">Members register</p>
            </div>
          </Link>
          {member ? (
            <nav className="flex items-center gap-1">
              <NavLink to="/profile" className={({ isActive }) => `flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm ${isActive ? 'bg-navy-700 text-white' : 'text-navy-100 hover:text-white'}`}>
                <User size={16} /><span className="hidden sm:inline">My profile</span>
              </NavLink>
              <NavLink to="/documents" className={({ isActive }) => `flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm ${isActive ? 'bg-navy-700 text-white' : 'text-navy-100 hover:text-white'}`}>
                <FolderOpen size={16} /><span className="hidden sm:inline">Documents</span>
              </NavLink>
              <button onClick={logout} title="Log out" className="rounded-lg px-3 py-2 text-navy-200 hover:text-white"><LogOut size={16} /></button>
            </nav>
          ) : (
            <nav className="flex items-center gap-2">
              <Link to="/login" className="px-3 py-2 text-sm text-navy-100 hover:text-white">Log in</Link>
              <Link to="/register" className="btn-gold btn-sm">Register</Link>
            </nav>
          )}
        </div>
        <div className="h-1 bg-gold-500" />
      </header>
      <main className={`mx-auto w-full flex-1 px-4 py-8 ${narrow ? 'max-w-md' : 'max-w-5xl'}`}>{children}</main>
      <footer className="border-t bg-white py-5 text-center text-xs text-gray-500">
        <p>{group?.name} · Your details are used only for group communication and are never shared or sold.</p>
        <p className="mt-1"><Link to="/privacy" className="underline hover:text-navy-700">Privacy &amp; consent</Link></p>
      </footer>
    </div>
  );
}
